import type { ReduxState } from '@spa/redux/ReduxState'
import { shallowEqual } from 'react-redux'

import useAppSelector from './useAppSelector'

/**
 * useSelector that apply shallow equals memoization by default
 */
const useShallowSelector = <T extends any>(
  selectorFn: (state: ReduxState) => T
) => {
  return useAppSelector(selectorFn, (a, b) => {
    return a === b || shallowEqual(a, b)
  })
}

export default useShallowSelector
